function getGretaAIChatFinanceAccess(response) {
  const {
    finance_access,
    finance_access_stale,
    finance_preview_seen,
    finance_used,
  } = response.data

  return {
    access: finance_access,
    isPreviewSeen: finance_preview_seen,
    isStale: finance_access_stale,
    isUsed: finance_used,
  }
}

// A check started before a refusal must not bring the access back, nor a stale
// one after it (only the backend's last known value), nor one started before the
// first Finance chat or the preview bring the New badge back.
export function getGretaAIChatNextFinanceAccess({
  current,
  response,
  revocation,
}) {
  const next = getGretaAIChatFinanceAccess(response)

  if (current.revocation !== revocation) {
    return current
  }

  const flags = {
    isPreviewSeen: next.isPreviewSeen || current.isPreviewSeen,
    isUsed: next.isUsed || current.isUsed,
  }

  return current.isRevoked && next.isStale
    ? { ...current, ...flags }
    : { ...next, ...flags, isRevoked: false, revocation }
}
